<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document-copy"></i> 作品管理</span>
      </div>
      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="80px"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="班级名称">
              <el-select
                v-model="queryParams.classId"
                placeholder="请选择班级"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in classOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="空间名称">
              <el-select
                v-model="queryParams.spaceId"
                placeholder="请选择空间"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in spaceOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="作者">
              <el-input
                v-model="queryParams.childName"
                placeholder="请输入作者"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="作品名称">
              <el-input
                v-model="queryParams.workName"
                placeholder="请输入作品名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="queryParams.dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                style="width: 95%"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="审核状态">
              <el-select
                v-model="queryParams.state"
                placeholder="请选择审核状态"
                style="width: 100%"
              >
                <el-option
                  v-for="item in auditStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button
            type="success"
            icon="el-icon-document"
            :disabled="isGenerating"
            @click="generateDoc"
            :loading="isGenerating"
          >
            {{ isGenerating ? "正在生成中..." : "生成档案" }}
          </el-button>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
        ref="table"
        @selection-change="handleSelectionChange"
      >
        <!-- 多选列 -->
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column label="作品预览" prop="preview">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.workFile"
              :src="scope.row.workFile"
              style="width: 50px; height: 50px"
              fit="cover"
              :preview-src-list="[scope.row.workFile]"
            ></el-image>
            <span v-else>无预览图</span>
          </template>
        </el-table-column>

        <el-table-column label="作品名称" prop="name"></el-table-column>
        <el-table-column label="作品介绍" prop="intro"></el-table-column>
        <el-table-column label="作者" prop="children"></el-table-column>
        <el-table-column label="班级" prop="clazzName"></el-table-column>
        <el-table-column label="所属空间" prop="spaceName"></el-table-column>
        <el-table-column label="状态" prop="state">
          <template v-slot="scope">
            {{
              scope.row.state === 1
                ? "审核通过"
                : scope.row.state === 0
                ? "待审核"
                : scope.row.state === 2
                ? "审核驳回"
                : "未知状态"
            }}
          </template>
        </el-table-column>
        <el-table-column label="审批意见" prop="rejectReason"></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          width="200"
        ></el-table-column>
        <el-table-column label="操作" width="150">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="editWork(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteWork(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog title="编辑作品" :visible.sync="dialogVisible" width="500px">
      <el-form
        ref="editForm"
        :model="currentWork"
        :rules="editFormRules"
        label-width="80px"
      >
        <el-form-item label="作品名称" prop="name">
          <el-input
            v-model="currentWork.name"
            placeholder="请输入作品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="作品介绍" prop="intro">
          <el-input
            v-model="currentWork.intro"
            type="textarea"
            placeholder="请输入作品介绍"
            :rows="4"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelEdit">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAllClazzList, workEdit, workArchive } from "@/api/repair";
import { workPage, spaceList, workDelete } from "@/api/config";
import PaginationBar from "@/components/PaginationBar";
import { omit, debounce } from "lodash";

export default {
  components: { PaginationBar },
  data() {
    return {
      dialogVisible: false,
      currentWork: {
        id: "",
        name: "",
        intro: "",
      },
      editFormRules: {
        name: [{ required: true, message: "请输入作品名称", trigger: "blur" }],
        intro: [{ required: true, message: "请输入作品介绍", trigger: "blur" }],
      },
      auditStatusOptions: [
        { label: "全部", value: "-1" },
        { label: "待审核", value: 0 },
        { label: "审核通过", value: 1 },
        { label: "审核驳回", value: 2 },
      ],
      queryParams: {
        state: "-1", // 状态： 0:待审核，1：审核通过 ，2：审核驳回
        classId: "",
        spaceId: "",
        dateRange: [],
        childName: "",
        workName: "",
      },
      classOptions: [],
      spaceOptions: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      selectedWorks: [], // 添加此变量用于存储选中的作品
      isGenerating: false,
    };
  },
  created() {
    this.getClassList();
    this.getAllSpace();
  },
  mounted() {
    // 在组件挂载后处理路由参数
    this.processRouteQuery();
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      if (to.path === "/creative-space/work-manage") {
        this.processRouteQuery();
      }
    },
  },
  methods: {
    // 处理路由查询参数
    processRouteQuery() {
      // 获取路由中的clazzName参数和childName参数
      const clazzName = this.$route.query.clazzName;
      const childName = this.$route.query.childName;

      // 处理儿童名称参数
      if (childName) {
        // 解码儿童名称并设置到查询条件中
        this.queryParams.childName = decodeURIComponent(childName);
      }

      if (clazzName) {
        // 解码班级名称
        const decodedClazzName = decodeURIComponent(clazzName);

        // 等待班级数据加载完成后再处理
        const handleClassSelection = () => {
          if (this.classOptions && this.classOptions.length > 0) {
            // 查找匹配的班级
            const matchedClass = this.classOptions.find(
              (item) => item.name === decodedClazzName
            );

            if (matchedClass) {
              // 设置选中的班级ID
              this.queryParams.classId = matchedClass.id;

              // 执行查询
              this.$nextTick(() => {
                this.handleQuery(1);
              });
            } else {
              // 如果没找到匹配的班级，执行常规查询
              this.handleQuery(1);
            }
          } else {
            // 如果班级数据还未加载完成，稍后重试
            setTimeout(handleClassSelection, 100);
          }
        };

        handleClassSelection();
      } else {
        // 没有clazzName参数时执行常规查询
        this.handleQuery(1);
      }
    },
    saveEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // 这里应该调用API保存编辑内容
          workEdit(this.currentWork).then((res) => {
            this.$message.success("编辑成功");
            this.dialogVisible = false;
            this.handleQuery(this.currentPage);
          });
        }
      });
    },

    cancelEdit() {
      this.dialogVisible = false;
    },
    editWork(row) {
      this.currentWork = {
        id: row.id,
        name: row.name,
        intro: row.intro,
      };
      this.dialogVisible = true;
    },
    // 请求所有的空间
    getAllSpace() {
      spaceList({
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        this.spaceOptions = res.records;
      });
    },
    getClassList() {
      getAllClazzList().then((res) => {
        this.classOptions = res || [];

        // 班级数据加载完成后，如果有路由参数需要处理，则再次处理
        if (this.$route.query.clazzName) {
          this.processRouteQuery();
        }
      });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      // 处理日期范围参数
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
        state: this.queryParams.state == "-1" ? "" : this.queryParams.state,
      };

      if (
        this.queryParams.dateRange &&
        this.queryParams.dateRange.length === 2
      ) {
        // 开始时间设置为当天 00:00:00
        params.startTime = `${this.queryParams.dateRange[0]} 00:00:00`;
        params.endTime = `${this.queryParams.dateRange[1]} 23:59:59`;
      }

      // 使用 omit 删除原来的 dateRange 参数
      params = omit(params, ["dateRange"]);
      // 这里改成请求作品列表接口
      workPage(params).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        state: "-1",
        classId: "",
        spaceId: "",
        dateRange: [],
        childName: "",
        workName: "",
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    generateDoc: debounce(function () {
      if (this.isGenerating) {
        this.$message.warning("正在生成档案，请稍后...");
        return;
      }

      if (!this.selectedWorks || this.selectedWorks.length === 0) {
        this.$message.warning("请选择作品");
        return;
      }

      this.isGenerating = true;

      const ids = this.selectedWorks.map((item) => item.id);

      workArchive(ids)
        .then((res) => {
          console.log("res", res);

          // ✅ 正确：真正的 PDF 在 res.data
          const blob = res.data;

          // ✅ 兜底 1：不是 Blob
          if (!(blob instanceof Blob)) {
            this.$message.error("生成失败，返回数据异常");
            return;
          }

          // ✅ 兜底 2：空文件
          if (blob.size === 0) {
            this.$message.error("生成的档案为空");
            return;
          }

          // ✅ 兜底 3：后端返回 JSON 错误
          if (blob.type.includes("application/json")) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const err = JSON.parse(reader.result);
                this.$message.error(err.msg || "生成失败");
              } catch {
                this.$message.error("生成失败");
              }
            };
            reader.readAsText(blob);
            return;
          }

          // ✅ 正常下载 PDF
          const pdfBlob = new Blob([blob], {
            type: "application/pdf",
          });

          const url = window.URL.createObjectURL(pdfBlob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "档案.pdf"; // 可换成动态文件名
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$message.success("作品档案生产成功");
        })
        .catch((error) => {
          console.error("生成档案失败:", error);
          this.$message.error("生成档案失败，请稍后重试");
        })
        .finally(() => {
          this.isGenerating = false;
        });
    }, 300),
    deleteWork(row) {
      this.$confirm("确定删除当前作品?", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        workDelete({
          id: row.id,
        }).then((res) => {
          this.$message.success("删除成功！");
          this.handleQuery();
        });
      });
    },
    handleSelectionChange(val) {
      // 将选中的数据赋值给 selectedWorks
      this.selectedWorks = val;
      console.log("选中作品", this.selectedWorks);
    },
  },
};
</script>
